import { KatalisTranslationRules } from '../translations.interface';

const messages: KatalisTranslationRules = {
  rules: {
    campoObrigatorio: 'Campo obrigatório',
    numerico: 'Campo numérico',
  },
};

export default messages;
